import { getTrackingData as getApiTrackingData } from '@/api/tracking'

const getTrackingSection = data => {
  return (
    data?.tracking?.tracking ||
    data?.tracking?.tracking_data ||
    data?.tracking ||
    data?.tracking_data ||
    {}
  )
}

const getUserTrackingData = () => {
  return {
    customer_id: null,
    customer_login_status: 'Logged Out',
    customer_gender: null,
    customer_birthday: null,
    customer_status: 'XX',
    customer_status_shop: '0',
    country_code: null,
    language_code: null,
    currency: 'EUR',
    shop_type: 'web',
  }
}

const screenMapping = {
  Cart: 'Cart Page',
  Checkout: 'Checkout Payment Page',
  CheckoutValidateAddresses: 'Checkout Customer Page',
  CartAddProduct: 'Cart Add Product Page',
  CartAddVoucher: 'Checkout Payment Page',
}

const isTrackingActive = () => {
  return Boolean(window?.utag?.view)
}

const buildTrackingData = (view, data = {}) => {
  const trackingSection = getTrackingSection(data)
  const { tracking, tracking_data, ...rest } = data || {}
  const pageName = screenMapping[view] || trackingSection.page_name || view

  return {
    ...getUserTrackingData(),
    ...trackingSection,
    ...rest,
    page_name: pageName,
    tealium_event: trackingSection.tealium_event || 'page_view',
    page_id: trackingSection.page_id || pageName,
    content_id: trackingSection.content_id || pageName,
    sitegroup: trackingSection.sitegroup || pageName.replace(/\s+/g, ''),
  }
}

const enrichTrackingData = async (view, data = {}, enrichWithString, enrichWithId, enrichWithQuery) => {
  if (!isTrackingActive()) {
    return data
  }

  if (enrichWithString) {
    const trackingData = await getApiTrackingData(enrichWithString, enrichWithId, enrichWithQuery)

    return {
      ...trackingData,
      ...data,
    }
  }

  return data
}

export const trackScreenView = async (view, data = {}, enrichWithString, enrichWithId, enrichWithQuery) => {
  if (!isTrackingActive()) return

  const enrichedData = await enrichTrackingData(view, data, enrichWithString, enrichWithId, enrichWithQuery)
  window.utag.view(buildTrackingData(view, enrichedData))
}

export const trackTealiumEvent = async (name, data = {}, enrichWithString, enrichWithId, enrichWithQuery) => {
  if (!isTrackingActive()) return

  const enrichedData = await enrichTrackingData(undefined, data, enrichWithString, enrichWithId, enrichWithQuery)

  window.utag.link({
    ...getUserTrackingData(),
    ...getTrackingSection(enrichedData),
    ...(() => {
      const { tracking, tracking_data, ...rest } = enrichedData || {}
      return rest
    })(),
    tealium_event: name,
  })
}
